import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Box, Link } from "@mui/material";
import styled from "@emotion/styled";
import { useLogout } from "@hooks";
import { Banner } from "@rentablo/components";
import { LoadingButton } from "@rentablo/components";

const Container = styled.div`
  width: 100%;
  max-width: 500px;
  & > :not(style) {
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }
`;

export interface EmailConfirmationContainerProps {
  onResendEmail: () => void;
  isMutationSuccess: boolean;
  isButtonLoading: boolean;
  error?: string | null;
}

export const EmailConfirmationContainer = ({
  error,
  isMutationSuccess,
  isButtonLoading,
  onResendEmail,
}: EmailConfirmationContainerProps) => {
  const { t } = useTranslation();
  const { logout } = useLogout();

  return (
    <Container data-testid="signup-email-confirmation">
      <Typography>{t("emailConfirmation.line1")}</Typography>
      <Typography>{t("emailConfirmation.line2")}</Typography>
      {error && (
        <Banner
          type="error"
          title={t("somethingWrong.shortTitle")}
          displayDefaultIcon
          text={
            <>
              {t("somethingWrong.subTitle")}
              {error && (
                <>
                  <Box mt={6}>
                    <Typography variant="body3">{error}</Typography>
                  </Box>
                </>
              )}
            </>
          }
        />
      )}
      {isMutationSuccess && (
        <Banner
          type="success"
          displayDefaultIcon
          text={t("emailConfirmation.success")}
        />
      )}
      <Box display="flex" alignItems="center" gap={5}>
        <LoadingButton
          data-testid="resend-email-button"
          onClick={onResendEmail}
          isFetching={isButtonLoading}
          disabled={isButtonLoading || isMutationSuccess}
        >
          {t("emailConfirmation.button")}
        </LoadingButton>
        <Link onClick={logout}>
          <Typography variant="body1">
            {t("emailConfirmation.logout")}
          </Typography>
        </Link>
      </Box>
    </Container>
  );
};
